import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { CORE_ROUTE } from "@obg/ngx.core";
import { PlatformService } from "@obg/ngx.global.evo";
import { RouteAction, RouteSelector, RouteService } from "@obg/ngx.router";
import { ignoreNil } from "@obg/rxjs";
import { Observable, of } from "rxjs";
import { filter, map, switchMap, take, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../state";

import { GeoFencingAction } from "./geofencing.action";
import { GeofencingSelector } from "./geofencing.selector";
import { GeofencingService } from "./geofencing.service";

@Injectable({ providedIn: "root" })
export class ArgentinaGeofencingGuard implements CanActivate {
	constructor(
		private platformService: PlatformService,
		private store: Store<CommonState>,
		private routeService: RouteService,
		private geofencingService: GeofencingService
	) {}

	canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		const route = this.routeService.getConfigFromStateSnapshot(state);

		if (
			this.platformService.isServer ||
			!this.geofencingService.isArgentinaGeofencingEnabled() ||
			this.geofencingService.isRouteExempt(route?.name)
		) {
			return of(true);
		}

		this.store.dispatch(GeoFencingAction.validateLocation());

		return this.store.select(GeofencingSelector.isBusy).pipe(
			filter((isBusy) => !isBusy),
			switchMap(() => this.store.select(GeofencingSelector.isValid)),
			ignoreNil(),
			take(1),
			withLatestFrom(this.store.select(RouteSelector.getCurrent)),
			map(([isValid, currentRoute]) => {
				if (!isValid && !currentRoute) {
					this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home, {}, { onSameUrlNavigation: "reload" }));
				}

				return isValid;
			})
		);
	}
}
